const PROJECT_SCOPED_ROUTE_PREFIXES = [
  '/overview',
  '/simple',
  '/annotate',
  '/myassets',
  '/myboxes',
  '/import',
  '/progress',
  '/models',
  '/auto',
  '/settings',
  '/mostconfused',
  '/instances',
  '/myprofile',
  '/profile',
];

export function parseProjectId(value) {
  if (value === null || value === undefined || value === '' || value === false || value === 'false') {
    return null;
  }
  const id = parseInt(value, 10);
  return Number.isNaN(id) ? null : id;
}

export function getCurrentProjectId(store) {
  const fromStore = store?.getters?.['user/get_current_project_id'];
  const parsedStore = parseProjectId(fromStore);
  if (parsedStore !== null) {
    return parsedStore;
  }
  return parseProjectId(sessionStorage.getItem('project_id'));
}

function isProjectScopedRoute(route) {
  if (typeof route !== 'string') {
    return false;
  }
  const path = route.split('?')[0];
  if (path === '/projects' || path === '/project') {
    return false;
  }
  return PROJECT_SCOPED_ROUTE_PREFIXES.some((prefix) => path === prefix || path.startsWith(`${prefix}/`));
}

export function withProjectQuery(route, projectId) {
  if (!projectId || !isProjectScopedRoute(route)) {
    return route;
  }

  const [path, search = ''] = route.split('?');
  const params = new URLSearchParams(search);
  params.set('project_id', String(projectId));
  return {
    path,
    query: Object.fromEntries(params.entries()),
  };
}

export function applyProjectIdFromQuery(to, store) {
  const queryId = parseProjectId(to.query?.project_id);
  if (queryId === null) {
    return;
  }
  const currentId = getCurrentProjectId(store);
  if (currentId !== queryId) {
    store.commit('user/set_current_project_id', queryId);
  }
}
